/* eslint-disable no-plusplus */
/* eslint-disable react/no-unused-state */
import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CommunityContextConsumer } from '../../../../contexts/CommunityContext';
import {
    PromotionalAdConsumer,
    PromotionalAdProvider,
} from '../../../../contexts/PromotionalAdContext';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import Button from '../../../Input/Button/Button';
import InfiniteScrollWrapper from '../../../Layout/InfiniteScrollWrapper/InfiniteScrollWrapper';
import PromotionalAd from '../../../PromoionalAd/PromotionalAd';
import LoadingShineComponent from '../LoadingShineComponent/LoadingShineComponent';
import UnifiedPostCard from '../../../UnifiedPostCard/UnifiedPostCard';
import { PageContext } from '../../../../contexts/ContextCreator';

import './CommunityFeeds.scss';

export const LOAD_MORE_BUTTON = 'load-more';
export const REDIRECT_TO_FEED = 'redirect';
export const NO_BUTTON = 'no-button';
export const TOPIC_LOAD_MORE_BUTTON = 'topic-load-more';

export default class CommunityFeeds extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            initialLoad: true,
            isLoading: true,
            direction: 'down',
            PixelFired: false,
        };
    }

    async componentDidMount() {
        this.props.fetchMoreContent({
            feedGroup: this.props.feedGroup,
            feedGroupId: this.props.feedGroupId,
            setIsLoading: this.setIsLoading,
            hash: this.props.communityGroupHash,
        });
        if (!this.state.infiniteScroll) {
            this.setIsLoading();
        }
    }

    setIsLoading = (isLoading = false, initialLoad = false) => {
        this.setState({ isLoading, initialLoad });
    };

    handleFetchMoreContent = async () => {
        const { isLoading } = this.state;
        const {
            fetchMoreContent,
            feedGroup,
            feedGroupId,
            communityGroupHash,
            metricEventType,
            hasNext,
            feedLastResultCount,
        } = this.props;
        this.setIsLoading(true);
        try {
            if (!isLoading && hasNext && feedLastResultCount !== 0) {
                await fetchMoreContent({
                    hash: communityGroupHash,
                    feedGroup,
                    feedGroupId,
                    setIsLoading: this.setIsLoading,
                    direction: 'up',
                });
                EmitMetric({
                    misc_event_type: metricEventType,
                    misc_event_count: 1,
                });
            }
        } catch (e) {
            this.setIsLoading();
        }
    };

    isUnifiedPostBoxFeatureFlag = () =>
        this.context?.pageProps?.featureFlags?.unifiedPostBox;

    renderFeeds = () => {
        return (
            <CommunityContextConsumer>
                {(communityContext) => (
                    <PromotionalAdConsumer>
                        {(adContext) => {
                            const { isLoading } = this.state;
                            const { infiniteScroll, hasNext } = this.props;
                            const {
                                masterFeedAdConfig,
                            } = this.context?.pageProps;
                            const components = [];
                            let adPosition = 0;

                            /*
                            Location variable below added for backwards compatibility.
                            The feedType property has been defining the location of content which is problematic.
                            Only if no location is passed as a prop to this component will the content location fall back to feed type
                            -MSH 071219
                        */
                            const location =
                                this.props.location || this.props.feedType;

                            // @TODO should refactor using .map()
                            for (
                                let i = 0;
                                i < communityContext.content.length;
                                i++
                            ) {
                                const content = communityContext.content[i];
                                if (
                                    content.moderationOption?.status?.type !==
                                    'delete'
                                ) {
                                    components.push(
                                        <UnifiedPostCard
                                            key={content.hash}
                                            {...content}
                                            location={location}
                                            feedType={this.props.feedType}
                                        />
                                    );
                                }

                                if (
                                    masterFeedAdConfig &&
                                    (i + 1) % masterFeedAdConfig.cadence === 0
                                ) {
                                    components.push(
                                        <PromotionalAd
                                            selectedAd={adContext.getAdAtPosition(
                                                adPosition
                                            )}
                                        />
                                    );
                                    adPosition++;
                                }
                            }
                            if (infiniteScroll) {
                                return (
                                    <InfiniteScrollWrapper
                                        pageStart={0}
                                        loadMore={this.handleFetchMoreContent}
                                        hasMore={hasNext}
                                        isLoading={isLoading}
                                        useWindow
                                        threshold={500}
                                    >
                                        {components}
                                    </InfiniteScrollWrapper>
                                );
                            }
                            return components;
                        }}
                    </PromotionalAdConsumer>
                )}
            </CommunityContextConsumer>
        );
    };

    loadShowMoreButton = () => {
        return (
            <CommunityContextConsumer>
                {(context) => {
                    if (this.props.endOfFeedButtonType === REDIRECT_TO_FEED) {
                        return (
                            <div className="loadMoreButtonDiv">
                                <a href="/community/feed">
                                    <Button
                                        type="solid"
                                        value={this.props.loadMoreButtonText}
                                    />
                                </a>
                            </div>
                        );
                    }
                    if (
                        this.props.endOfFeedButtonType ===
                            TOPIC_LOAD_MORE_BUTTON &&
                        context.content &&
                        context.content.length < this.props.topicContentTotal
                    ) {
                        return (
                            <div className="loadMoreButtonDiv">
                                <Button
                                    type="solid"
                                    value={this.props.loadMoreButtonText}
                                    onClick={() => {
                                        context.fetchMoreContent(
                                            this.props.topicLoadMoreObject
                                        );
                                        EmitMetric(this.props.topicMetrics);
                                    }}
                                />
                            </div>
                        );
                    }
                    if (this.props.endOfFeedButtonType === NO_BUTTON) {
                        return null;
                    }
                    return null;
                }}
            </CommunityContextConsumer>
        );
    };

    render() {
        return (
            <div className="component-Content-Feed-CommunityFeeds">
                <PromotionalAdProvider
                    pageKey={this.context.getPageKey()}
                    isMobile={this.context.isMobile}
                >
                    <React.Fragment>
                        {this.renderFeeds()}
                        {this.loadShowMoreButton()}
                        {this.state.initialLoad ? (
                            <React.Fragment>
                                <LoadingShineComponent />
                                <LoadingShineComponent />
                                <LoadingShineComponent />
                            </React.Fragment>
                        ) : null}
                        {this.state.isLoading &&
                        this.props.feedLastResultCount !== 0 ? (
                            <LoadingShineComponent />
                        ) : null}
                    </React.Fragment>
                </PromotionalAdProvider>
            </div>
        );
    }
}

CommunityFeeds.propTypes = {
    feedType: PropTypes.oneOf(['miniFeed', 'masterFeed']).isRequired,
    feedGroup: PropTypes.oneOf([
        'CommunityDiscussion',
        'CommunityLink',
        'CommunityTopic',
        'CommunityTag',
        'EditorialContent',
        'GlobalFeed',
        'Company',
        'GroupFeed',
    ]).isRequired,
    feedGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadMoreButtonText: PropTypes.string,
    createContentEnabled: PropTypes.bool,
    /**
     * if true load more button if false, redirect button
     */
    hasNext: PropTypes.bool.isRequired,
    feedLastResultCount: PropTypes.number,
    endOfFeedButtonType: PropTypes.oneOf([
        LOAD_MORE_BUTTON,
        REDIRECT_TO_FEED,
        NO_BUTTON,
    ]),
    metricEventType: PropTypes.string,
    useCommonCardShell: PropTypes.bool,
    /**
     * group hash required when fetching a group feed
     */
    communityGroupHash: PropTypes.string,
    /**
     * the location of the feed (for metrics purposes)
     */
    location: PropTypes.oneOf(['masterFeed', 'groupFeed', 'topic-load-more']),
    hideReactionBar: PropTypes.bool,
    infiniteScroll: PropTypes.bool,
    fetchMoreContent: PropTypes.func,
    topicContentTotal: PropTypes.number,
    topicMetrics: PropTypes.shape({
        misc_event_count: PropTypes.number,
        misc_event_type: PropTypes.string,
    }),
    topicLoadMoreObject: PropTypes.shape({
        topicUrl: PropTypes.string,
    }),
    userRelation: PropTypes.shape({
        role: PropTypes.string,
    }),
};

CommunityFeeds.defaultProps = {
    infiniteScroll: true,
    feedGroupId: '',
    loadMoreButtonText: 'Load more',
    createContentEnabled: true,
    endOfFeedButtonType: LOAD_MORE_BUTTON,
    metricEventType: 'community-feed-load-more',
    hideReactionBar: false,
    useCommonCardShell: true,
    communityGroupHash: '',
    location: 'masterFeed',
    topicMetrics: {},
    fetchMoreContent: () => {},
    topicContentTotal: 0,
    topicLoadMoreObject: {},
    feedLastResultCount: 0,
    userRelation: {},
};

CommunityFeeds.contextType = PageContext;
